import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Heart } from "lucide-react";
import { navLinks, rotatingFooterQuotes } from "../mock";
import { useSiteContent } from "../admin/SiteContentContext";

export default function Footer() {
  const { content } = useSiteContent();
  const siteInfo = content.siteInfo;
  const [quoteIdx, setQuoteIdx] = React.useState(0);
  React.useEffect(() => {
    const t = setInterval(() => setQuoteIdx(i => (i + 1) % rotatingFooterQuotes.length), 6500);
    return () => clearInterval(t);
  }, []);

  return (
    <footer className="border-t border-white/5 bg-[#070b17] mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 shrink-0 rounded-xl bg-white/95 p-1 flex items-center justify-center">
                <img src={siteInfo.logo} alt="3E DanCare" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="text-white font-semibold">{siteInfo.brand} LLC</div>
                <div className="text-xs text-slate-400">{siteInfo.tagline}</div>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              Thoughtful, non-medical companion and homemaker support — so the people you love can keep living life on their terms.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Explore</h4>
            <ul className="space-y-2">
              {navLinks.map(l => (
                <li key={l.to}><Link to={l.to} className="text-slate-400 hover:text-[#c7e34a] text-sm">{l.label}</Link></li>
              ))}
              <li><Link to="/booking" className="text-slate-400 hover:text-[#c7e34a] text-sm">Book Consultation</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Reach us</h4>
            <ul className="space-y-3">
              <li>
                <a href={`tel:${siteInfo.phone}`} className="text-slate-300 hover:text-white flex items-center gap-2 text-sm">
                  <Phone className="w-4 h-4 text-[#c7e34a]" /> {siteInfo.phone}
                </a>
              </li>
              <li>
                <a href={`tel:${siteInfo.tollFree}`} className="text-slate-300 hover:text-white flex items-center gap-2 text-sm">
                  <Phone className="w-4 h-4 text-[#c7e34a]" /> {siteInfo.tollFree}
                </a>
              </li>
              <li>
                <a href={`mailto:${siteInfo.email}`} className="text-slate-300 hover:text-white flex items-center gap-2 text-sm">
                  <Mail className="w-4 h-4 text-[#c7e34a]" /> {siteInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="section-divider my-10" />

        <p className="text-center text-slate-400 italic text-sm max-w-3xl mx-auto transition-opacity duration-500" key={quoteIdx}>
          {rotatingFooterQuotes[quoteIdx]}
        </p>

        <div className="mt-10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <div className="flex items-center gap-2">
            <Heart className="w-3.5 h-3.5 text-[#c7e34a]" />
            <span>© {new Date().getFullYear()} 3E DanCare LLC. All rights reserved.</span>
          </div>
          <div className="flex gap-5">
            <span>Non-medical services only</span>
            <span>Private pay</span>
            <span>Equal opportunity</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
